export default class CreateConjuntoEvaluacionesUseCase {
  constructor(repository) {
    this.repository = repository
  }

  async execute({
    fk_idRespetoPrincipios = null,
    fk_idDisciplinaAdministrativa = null,
    fk_idDisciplinaOperativa = null,
    fk_idProductividad = null,
    fk_idRespetoPrincipiosValores = null,
    fk_idDesempenioInstitucional = null,
    fk_idRendimientoProfesionalismo = null,
    idPersonal,
  }) {
    await this.repository.createConjuntoEvaluaciones({
      fk_idRespetoPrincipios,
      fk_idDisciplinaAdministrativa,
      fk_idDisciplinaOperativa,
      fk_idProductividad,
      fk_idRespetoPrincipiosValores,
      fk_idDesempenioInstitucional,
      fk_idRendimientoProfesionalismo,
      idPersonal,
    })
  }
}
